import { cn } from '@shared/utils';

export interface IconIndicatorProps {
  type: 'dot' | 'counter';
  count?: number;
  colorClass?: string;
  className?: string;
}

export const IconIndicator = ({ type, count = 0, colorClass, className }: IconIndicatorProps) => {
  if (type === 'counter' && count <= 0) return null;

  const isDot = type === 'dot';
  const displayCount = !isDot && count > 99 ? '99+' : count;

  return (
    <span
      className={cn(
        'absolute flex items-center justify-center rounded-full pointer-events-none font-bold ',
        isDot
          ? 'size-2.5 top-0.5 right-0.5 bg-primary'
          : '-top-3 -right-3 h-6 min-w-6 px-1.5 text-[12px] leading-none select-none tabular-nums font-extrabold bg-transparent',
        colorClass ?? 'text-primary',
        className,
      )}
    >
      {!isDot && displayCount}
    </span>
  );
};
